import React from "react";

// Plain function version
export const titleCase = (str: any): string => {
  if (typeof str !== "string") return "";
  return str
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

const ToTitleCase: React.FC<{ text: any }> = ({ text }) => {
  return <>{titleCase(text)}</>;
};

export default ToTitleCase;

